import Cookies from "js-cookie"

export const readFromCookie = name => {
  return Cookies.get(name)
}

export const writeToCookie = (name, value) => {
  Cookies.set(name.toString(), value.toString())
}
